import React from 'react';
import { Button } from 'antd-v5';
import { ArrowLeftOutlined, UndoOutlined } from '@ant-design/icons';

const MergeFieldRow = ({ label, keptValue, sourceValue, isOverridden, onCopy, onUndo, readOnly }) => {
  const valuesAreSame = (keptValue || '') === (sourceValue || '');
  const sourceHasValue = !!sourceValue;

  const getButtonState = () => {
    if (readOnly) return 'disabled';
    if (isOverridden) return 'revert';
    if (sourceHasValue && !valuesAreSame) return 'copy';
    return 'disabled';
  };

  const buttonState = getButtonState();
  const isNameField = label === 'NAME';
  const fieldKey = String(label)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  const copyButtonTestId = `clients__merge--copy-button--${fieldKey}`;

  const renderValue = (value, isKeptSide) => {
    if (!value) return null;
    const valueClass = isNameField ? 'merge-field-value' : 'merge-field-value merge-field-value--regular';
    return (
      <span className={valueClass}>
        {value}
        {isKeptSide && isOverridden && <span className="merge-field-new-badge">NEW</span>}
      </span>
    );
  };

  return (
    <>
      {/* Kept (left) side */}
      <div className="merge-field-row">
        <span className="merge-field-label">{label}</span>
        {renderValue(isOverridden ? sourceValue : keptValue, true)}
      </div>

      {/* Arrow button (center) */}
      <div className="merge-field-arrow-btn">
        {buttonState === 'copy' && (
          <Button size="small" icon={<ArrowLeftOutlined />} onClick={onCopy} data-testid={copyButtonTestId} />
        )}
        {buttonState === 'revert' && (
          <Button size="small" icon={<UndoOutlined />} onClick={onUndo} data-testid={copyButtonTestId} />
        )}
        {buttonState === 'disabled' && (
          <Button size="small" icon={<ArrowLeftOutlined />} disabled data-testid={copyButtonTestId} />
        )}
      </div>

      {/* Archived (right) side */}
      <div className="merge-field-row">
        <span className="merge-field-label">{label}</span>
        {renderValue(sourceValue, false)}
      </div>
    </>
  );
};

export default MergeFieldRow;
